import { render, staticRenderFns } from "./FaqAndSupportContacts.vue?vue&type=template&id=54dd4562&scoped=true"
import script from "./FaqAndSupportContacts.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportContacts.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportContacts.vue?vue&type=style&index=0&id=54dd4562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd4562",
  null
  
)

export default component.exports